export type DeferredPromise<T = any> = {
  promise: Promise<T>;
  resolve: (value: PromiseLike<T> | T) => void;
  reject: (reason?: any) => void;
  resolveIfValue: (value: PromiseLike<T> | T) => boolean;
};

/**
 * Deferred (aka delayed) promise which can be resolved from an outside caller,
 * e.g. app resolves the promise with token value after fetching the token asynchronously in their code.
 */
export const useDeferredPromise = <T>(): DeferredPromise<T> => {
  let resolveOuter: (value: T | PromiseLike<T>) => void;
  let rejectOuter: (reason?: any) => void;

  const promise = new Promise<T>((resolve, reject) => {
    resolveOuter = resolve;
    rejectOuter = reject;
  });

  return {
    promise,
    resolve: (value: PromiseLike<T> | T) => resolveOuter(value),
    reject: (reason?: any) => rejectOuter(reason),
    resolveIfValue: (value: PromiseLike<T> | T, rejectReason?: any) => {
      if (value) {
        resolveOuter(value);
        return true;
      }

      rejectOuter(rejectReason);
      return false;
    },
  };
};
